import { render } from "./CriticalDPModal.vue?vue&type=template&id=05ac5e07&scoped=true"
import script from "./CriticalDPModal.js?vue&type=script&lang=js"
export * from "./CriticalDPModal.js?vue&type=script&lang=js"

import "./CriticalDPModal.vue?vue&type=style&index=0&id=05ac5e07&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ac5e07"]])

export default __exports__